module.exports = __webpack_public_path__ + "static/media/app icon (11).5420fd5a.png";